import DOMPurify from 'dompurify'

export const purifySvg = (svg: string) => {
  return DOMPurify.sanitize(
    svg,
    {
      USE_PROFILES: {svg: true, svgFilters: true},
      ADD_TAGS: ['use'],
      ALLOW_DATA_ATTR: false
    }
  )
}

export const purifyHtml = (html: string) => {
  return DOMPurify.sanitize(html, {USE_PROFILES: {html: true}})
}

export const purifyAny = (html: string) => DOMPurify.sanitize(html)
